/**
 * CommentUpdateReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * CommentUpdateReq
 */
export interface CommentUpdateReq {
  /** 评论ID */
  id?: string
  /** 评论内容 */
  text?: string
  /** 文件ID列表 */
  file_ids?: string[][]
}

/**
 * CommentUpdateReq Schema
 */
export const CommentUpdateReqSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '评论ID',
      format: 'string',
      type: 'string',
      label: '评论ID',
    },
    text: {
      description: '评论内容',
      format: '*string',
      maxLength: 5000,
      type: 'string',
      label: '评论内容',
    },
    file_ids: {
      description: '文件ID列表',
      format: '*[]string',
      items: {
        format: '[]string',
        items: {
          format: 'string',
          type: 'string',
        },
        type: 'array',
      },
      type: 'array',
      label: '文件ID列表',
    },
  },
  type: 'object',
}
